import { CONSTANTS__client } from '@/constants/CONSTANTS__client';
import { use_slice_ui } from '@/hooks/store/use_slices';
import { useState } from 'react';
import { SidebarNavigationDesktop } from '../_base/sidebar_navigation/desktop/SidebarNavigationDesktop';
import { SidebarWrapper } from '../_base/SidebarWrapper';
import { TopbarInfoWrapper } from '../_base/TopbarInfoWrapper';
import { EReservationAssetType, ReservationAseetsTypesList } from './ReservationAssetsTypesList';
import { ReservationCreateButton } from './ReservationCreateButton';
import { ReservationsAssetsBundleTable } from './reservations_table/reservation_assets_bundle_table';
import { ReservationsTable } from './reservations_table/reservation_table';
import { ReservationsAssetsTable } from './reservations_table/reservations_assets_table';
import { ReservationTabsDropdown } from './ReservationTabsDropdown';

export enum ETabsReservations {
  CREATE_RESERVATION = 'create_reservation',
  RESERVATIONS = 'reservations',
}

export function PageReservationsViewsDesktop() {
  const { global_is_mobile } = use_slice_ui(['global_is_mobile']);

  let topbar_height = `calc(100% - ${CONSTANTS__client.TOPBAR_HEIGHT}px)`;

  const [current_tab, set_current_tab] = useState(ETabsReservations.RESERVATIONS);

  const [current_reservation_asset, set_current_reservation_asset] = useState(EReservationAssetType.VAE);

  /*
   * EVENTS
   */

  /*
   * EFFECTS
   */

  /*
   * RENDERS
   */

  function render_assets_table() {
    if (current_reservation_asset === EReservationAssetType.BUNDLE) {
      return <ReservationsAssetsBundleTable />;
    }

    return <ReservationsAssetsTable current_asset_type={current_reservation_asset} />;
  }

  /*
   * HTML
   */

  return (
    <div className="w-full relative flex h-screen text-center">
      <SidebarNavigationDesktop />

      <div
        className={`h-full bg-component text-page-foreground flex text-left`}
        style={{ width: `${global_is_mobile ? '100%' : `calc(100vw - ${CONSTANTS__client.DESKTOP_NAV_BAR_WIDTH}px)`}` }}
      >
        <SidebarWrapper>
          <TopbarInfoWrapper />
          <div className={` flex  flex-col  pt-2  bg-bar`} style={{ height: topbar_height, maxHeight: topbar_height }}>
            <ReservationTabsDropdown set_current_tab={set_current_tab} current_tab={current_tab} />
            {current_tab === ETabsReservations.CREATE_RESERVATION && (
              <ReservationAseetsTypesList current_reservation_asset={current_reservation_asset} set_current_reservation_asset={set_current_reservation_asset} />
            )}
          </div>
        </SidebarWrapper>
        <div style={{ width: `calc(100% - ${CONSTANTS__client.SIDEBAR_LEFT_WIDTH}px` }} className={`h-full flex flex-col`}>
          <TopbarInfoWrapper>
            <span className="flex items-center justify-start px-4"></span>
          </TopbarInfoWrapper>
          <div className="w-full  gap-2 flex flex-col" style={{ height: topbar_height }}>
            <div className="w-full h-[56px] flex items-center border-b bg-bar px-5 ">
              {current_tab === ETabsReservations.CREATE_RESERVATION && <ReservationCreateButton on_click={() => {}} total_ram_amount={1} />}
            </div>

            <div className="w-full h-full flex flex-col gap-3 px-5">
              {current_tab === ETabsReservations.RESERVATIONS && <ReservationsTable />}
              {current_tab === ETabsReservations.CREATE_RESERVATION && render_assets_table()}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
